import React, { useEffect, useState } from "react";
import axios from "../../auth/auth";
import { IoAddCircleOutline, IoClose } from "react-icons/io5";
import { IoApps, IoList } from "react-icons/io5";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FiUpload, FiDownload, FiEdit, FiTrash2 } from "react-icons/fi";



const emptyForm = {
  mode: "create",
  GarageID: "",
  CustomerID: "",
  Status: "Active",
  GarageName: "",
  Location: "",
  SizeSpaces: 0,
  EntryGates: 0,
  ExitGates: 0,
  Address: "",

  TransientRate: 0,
  FreeTransientAllowed: 0,
  TransientFreeRate: 0,
  FreeTransientFreeAllowed: 0,

  ReservationsRate: 0,
  FreeReservationsAllowed: 0,

  RatePerPermit: 0,
  FreePermitAllowed: 0,

  RatePerApp: 0,
  FreeAppAllowed: 0,

  EventsRate: 0,
  FreeEventsAllowed: 0,

  PassesRate: 0,
  FreePassesAllowed: 0,

  MonthlyFixedCharges: 0,
  GatewayFees: 0,
  citation_charges: 0,
  amount_collected_charges: 0,
  parking_validation_service: 0,

  items_tax: 0,
  installation_tax: 0,
  subscription_tax: 0,

  subscription_terms: "",
  payment_terms: "",

  ActiveLicenses: 0,
};

const statusOptions = [
  "Active",
  "Inactive",
  "Maintenance",
  "Onboarding",
];

export default function GarageSitesTab() {

  const [garages, setGarages] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [view, setView] = useState("cards");
  const [formOpen, setFormOpen] = useState(false);
  const [formData, setFormData] = useState({ SizeSpaces: 1 });
  const [searchTerm, setSearchTerm] = useState("");
  const [filterCustomer, setFilterCustomer] = useState("all");
  const [filterStatus, setFilterStatus] = useState("all");
  const [loading, setLoading] = useState(true);
  const [subscriptionServices, setSubscriptionServices] = useState([
    { id: null, item_name: "", monthly_price: "", billing_unit: "" }
  ]);

  const [installationExpenses, setInstallationExpenses] = useState([
    { id: null, expense_name: "", expense_quantity: 1, price: "" }
  ]);

  const [uploadingGarageId, setUploadingGarageId] = useState(null);
  const [downloadingGarageId, setDownloadingGarageId] = useState(null);

  const userRole = typeof window !== "undefined" ? sessionStorage.getItem("role") : null;
  const disabledPricingFields = [
    "TransientRate", "FreeTransientAllowed", "TransientFreeRate", "FreeTransientFreeAllowed",
    "ReservationsRate", "FreeReservationsAllowed",
    "RatePerPermit", "FreePermitAllowed",
    "RatePerApp", "FreeAppAllowed",
    "EventsRate", "FreeEventsAllowed",
    "PassesRate", "FreePassesAllowed",
    "MonthlyFixedCharges", "GatewayFees", "ActiveLicenses",
    "citation_charges", "amount_collected_charges", "parking_validation_service"
  ];

  const isFieldDisabled = (key) => userRole === "Sales" && disabledPricingFields.includes(key);

  // Load garages
  const loadGarages = async () => {
    try {
      const res = await axios.get("/garages/");
      setGarages(res.data || []);
    } catch (err) {
      console.error("Failed to load garages", err);
      setGarages([]);
    }
  };

  // Load customers (for dropdown filter and form)
  const loadCustomers = async () => {
    try {
      const res = await axios.get("/customers/");
      setCustomers(res.data || []);
    } catch (err) {
      console.error("Failed to load customers", err);
      setCustomers([]);
    }
  };

  // Load subscription services for a garage
  const fetchSubscriptionServices = async (garageId) => {
    try {
      const res = await axios.get(
        `/garages/${garageId}/subscription-services`
      );

      if (res.data && res.data.length > 0) {
        setSubscriptionServices(
          res.data.map((s) => ({
            id: s.id,
            item_name: s.item_name,
            monthly_price: Number(s.monthly_price),
            billing_unit: s.billing_unit || "",
          }))
        );
      } else {
        setSubscriptionServices([
          {
            id: null, item_name: "", monthly_price: "", billing_unit: "",
          },
        ]);
      }
    } catch (error) {
      console.error("Failed to load subscription services", error);
    }
  };

  // installation services
  const fetchInstallationExpenses = async (garageId) => {
    try {
      const res = await axios.get(
        `/garages/${garageId}/installation-expenses`
      );

      if (res.data && res.data.length > 0) {
        setInstallationExpenses(
          res.data.map((e) => ({
            id: e.id,
            expense_name: e.expense_name,
            expense_quantity: Number(e.expense_quantity || 1),
            price: Number(e.price),
          }))
        );
      } else {
        setInstallationExpenses([
          { id: null, expense_name: "", expense_quantity: 1, price: "" },
        ]);
      }
    } catch (error) {
      console.error("Failed to load installation expenses", error);
    }
  };

  const addExpenseRow = () => {
    setInstallationExpenses([
      ...installationExpenses,
      { id: null, expense_name: "", expense_quantity: 1, price: "" }
    ]);
  };

  const removeExpenseRow = async (index) => {
    const item = installationExpenses[index];

    try {
      if (item.id) {
        await axios.delete(
          `/garages/${formData.GarageID}/installation-expenses/${item.id}`
        );
      }

      const updated = [...installationExpenses];
      updated.splice(index, 1);

      if (updated.length === 0) {
        updated.push({ id: null, expense_name: "", expense_quantity: 1, price: "" });
      }

      setInstallationExpenses(updated);
    } catch (error) {
      console.error("Failed to delete expense", error);
      alert("Error deleting expense");
    }
  };

  const handleExpenseChange = (index, field, value) => {
    const updated = [...installationExpenses];
    updated[index][field] = value;
    setInstallationExpenses(updated);
  };


  const saveInstallationExpenses = async (garageId) => {
    try {
      const payload = installationExpenses
        .filter((e) => e.expense_name)
        .map((e) => ({
          id: e.id || undefined,
          expense_name: e.expense_name,
          expense_quantity: Number(e.expense_quantity || 1),
          price: Number(e.price || 0),
        }));

      await axios.put(
        `/garages/${garageId}/installation-expenses`,
        payload
      );
    } catch (error) {
      console.error("Failed to save installation expenses", error);
      alert("Error saving installation expenses");
    }
  };

  // useEffect(() => {
  //   loadGarages();
  //   loadCustomers();
  // }, []);


  useEffect(() => {
    const init = async () => {
        try {
            setLoading(true);

            await Promise.all([
                loadCustomers(),
                loadGarages()
            ]);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    init();
}, []);

  // Open modal for add or edit
  const openForm = async (garage = null) => {
    if (garage) {
      const formatted = {
        ...garage,
        mode: "edit",
        ExitGates: Number(garage.ExitGates),
        TransientRate: Number(garage.TransientRate),
        FreeTransientAllowed: Number(garage.FreeTransientAllowed),
        TransientFreeRate: Number(garage.TransientFreeRate),
        FreeTransientFreeAllowed: Number(garage.FreeTransientFreeAllowed),
        ReservationsRate: Number(garage.ReservationsRate),
        FreeReservationsAllowed: Number(garage.FreeReservationsAllowed),
        RatePerPermit: Number(garage.RatePerPermit),
        FreePermitAllowed: Number(garage.FreePermitAllowed),
        RatePerApp: Number(garage.RatePerApp),
        FreeAppAllowed: Number(garage.FreeAppAllowed),
        EventsRate: Number(garage.EventsRate),
        FreeEventsAllowed: Number(garage.FreeEventsAllowed),
        PassesRate: Number(garage.PassesRate),
        FreePassesAllowed: Number(garage.FreePassesAllowed),
        MonthlyFixedCharges: Number(garage.MonthlyFixedCharges),
        GatewayFees: Number(garage.GatewayFees),
        citation_charges: Number(garage.citation_charges),
        amount_collected_charges: Number(garage.amount_collected_charges),
        parking_validation_service: Number(garage.parking_validation_service),
        ActiveLicenses: Number(garage.ActiveLicenses),
        subscription_terms: garage.subscription_terms || "",
        payment_terms: garage.payment_terms || "",

        items_tax: Number(garage.items_tax || 0),
        installation_tax: Number(garage.installation_tax || 0),
        subscription_tax: Number(garage.subscription_tax || 0),
      };

      setFormData(formatted);

      //  Load subscription services for edit
      await fetchSubscriptionServices(garage.GarageID);
      await fetchInstallationExpenses(garage.GarageID);
    } else {
      setFormData(emptyForm);

      // Reset subscription rows
      setSubscriptionServices([
        {
          id: null, item_name: "", monthly_price: "", billing_unit: "",
        },
      ]);


      setInstallationExpenses([
        { id: null, expense_name: "", expense_quantity: 1, price: "" }
      ]);
    }

    setFormOpen(true);
  };

  // Save garage (create or update)

  // const validateForm = (data) => {
  //   if (!data.GarageID) return "Garage ID is required.";
  //   if (!data.CustomerID) return "Customer is required.";
  //   if (!data.Status) return "Status is required.";
  //   if (!data.GarageName) return "Garage Name is required.";
  //   return null; // No errors
  // };

  // Validate garage form before saving
  const validateForm = (data, mode = "create") => {
    if (!data.GarageID || !data.GarageID.trim()) return "Garage ID* is required.";
    if (!data.CustomerID || !data.CustomerID.trim()) return "Customer* is required.";
    if (!data.Status || !data.Status.trim()) return "Status* is required.";
    if (!data.GarageName || !data.GarageName.trim()) return "Garage Name* is required.";

    // Check for duplicate GarageID only when creating
    if (mode === "create") {
      const exists = garages.find((g) => g.GarageID === data.GarageID);
      if (exists) return "Garage ID already exists. Please use a different ID.";
    }

    return null; // No errors
  };

  // Updated handleSave using validation
  const handleSave = async () => {
    const mode = formData.mode || "create";
    const errorMessage = validateForm(formData, mode);
    if (errorMessage) {
      alert(errorMessage);
      return;
    }

    try {
      if (mode === "edit") {
        // Do not allow changing GarageID on edit
        await axios.put(`/garages/${formData.GarageID}`, formData);
      } else {
        // Create new garage
        await axios.post("/garages/create", formData);
      }

      // Save subscription services after garage is saved
      await saveSubscriptionServices(formData.GarageID);
      await saveInstallationExpenses(formData.GarageID);

      setFormOpen(false);
      loadGarages();
    } catch (error) {
      console.error("Failed to save garage:", error);
      alert(error.response?.data?.detail || "Error saving garage. Check console.");
    }
  };


  // Delete garage
  const deleteGarage = async (id) => {
    if (!window.confirm("Delete this garage?")) return;
    try {
      await axios.delete(`/garages/${id}`);
      loadGarages();
    } catch (error) {
      // console.error("Failed to delete garage:", error);
      const errorMessage = error.response?.data?.detail || error.response?.data?.message || "Error deleting garage";
      alert(errorMessage);
    }
  };

  // Sow routes


  const handleUploadSOW = async (garageId, file) => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      setUploadingGarageId(garageId);

      await axios.post(
        `/garages/${garageId}/upload-sow`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("SOW uploaded successfully");
      loadGarages(); // refresh

    } catch (err) {
      console.error(err);
      alert(err.response?.data?.detail || "Upload failed");
    } finally {
      setUploadingGarageId(null);
    }
  };

  const handleDownloadSOW = async (garageId, filename) => {
  try {
    setDownloadingGarageId(garageId);

    const res = await axios.get(
      `/garages/${garageId}/download-sow`,
      { responseType: "blob" }
    );

    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;

    link.download = filename || "sow.pdf";

    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (err) {
    console.error(err);
    alert("Download failed");
  } finally {
    setDownloadingGarageId(null);
  }
};


  const addSubscriptionRow = () => {
    setSubscriptionServices([
      ...subscriptionServices,
      {
        id: null, item_name: "", monthly_price: "", billing_unit: "", subscription_terms: "",
        payment_terms: ""
      },
    ]);
  };

  const removeSubscriptionRow = async (index) => {
    const service = subscriptionServices[index];

    try {
      // If record exists in DB → delete from backend
      if (service.id) {
        await axios.delete(
          `/garages/${formData.GarageID}/subscription-services/${service.id}`
        );
      }

      const updated = [...subscriptionServices];
      updated.splice(index, 1);

      if (updated.length === 0) {
        updated.push({
          id: null,
          item_name: "",
          monthly_price: "",
          billing_unit: "",
        });
      }

      setSubscriptionServices(updated);
    } catch (error) {
      console.error("Failed to delete subscription service", error);
      alert("Error deleting subscription service.");
    }
  };

  const handleSubscriptionChange = (index, field, value) => {
    const updated = [...subscriptionServices];
    updated[index][field] = value;
    setSubscriptionServices(updated);
  };


  const saveSubscriptionServices = async (garageId) => {
    try {
      const formattedPayload = subscriptionServices
        .filter((s) => s.item_name) // avoid empty rows
        .map((service) => ({
          id: service.id || undefined,
          item_name: service.item_name,
          monthly_price: Number(service.monthly_price || 0),
          billing_unit: service.billing_unit,
        }));

      await axios.put(
        `/garages/${garageId}/subscription-services`,
        formattedPayload
      );
    } catch (error) {
      console.error("Failed to save subscription services", error);
      alert("Error saving subscription services");
    }
  };

  // Filtering & searching
  const filteredGarages = garages.filter((g) => {
    if (
      filterCustomer !== "all" &&
      g.CustomerID !== filterCustomer
    )
      return false;

    if (
      filterStatus !== "all" &&
      g.Status !== filterStatus
    )
      return false;

    if (
      searchTerm &&
      !(
        g.GarageName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        g.Location?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        g.Address?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
      return false;

    return true;
  });

  if (loading) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                <p className="text-gray-600 text-sm">Loading Garages...</p>
            </div>
        </div>
    );
}

  return (
    <div className="p-2">

      {/* HEADER + CONTROLS */}
      {/* <div className=" gap-4 mb-6">
        <h1 className="text-2xl font-bold">Garage Sites</h1>
        <p className="text-gray-600">Manage parking garage locations</p>

      </div> */}

      {/* SEARCH + FILTERS */}
      <div className="flex flex-col md:flex-row gap-4 items-center mb-6">
        <input
          type="text"
          placeholder="Search garage sites..."
          className="border rounded-lg p-2 flex-grow md:flex-grow-0 md:w-96"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <select
          className="border rounded-lg p-2"
          value={filterCustomer}
          onChange={(e) => setFilterCustomer(e.target.value)}
        >
          <option value="all">All Customers</option>
          {customers.map((c) => (
            <option key={c.CustomerID} value={c.CustomerID}>
              {c.CustomerName || c.Corporation || c.CustomerID}
            </option>
          ))}
        </select>
        <select
          className="border rounded-lg p-2"
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
        >
          <option value="all">All Statuses</option>
          {statusOptions.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>

        <div className="ml-auto flex gap-2">
          <button
            onClick={() => setView("cards")}
            className={`px-4 py-2 rounded-lg flex items-center gap-2 ${view === "cards" ? "bg-blue-600 text-white" : "bg-white"
              }`}
          >
            <IoApps /> Cards
          </button>
          <button
            onClick={() => setView("table")}
            className={`px-4 py-2 rounded-lg flex items-center gap-2 ${view === "table" ? "bg-blue-600 text-white" : "bg-white"
              }`}
          >
            <IoList /> Table
          </button>
          <button
            onClick={() => openForm()}
            className="ml-auto bg-blue-600 text-white px-4 py-2 rounded-lg"
          >
            + Add Garage Site
          </button>
        </div>
      </div>

      {/* CARDS VIEW */}
      {view === "cards" && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {filteredGarages.map((g) => (
            <div
              key={g.GarageID}
              className="bg-white shadow p-6 rounded-xl border border-gray-100"
            >
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-lg font-semibold">{g.GarageName}</h2>
                  <p className="text-sm text-gray-500">{customers.find(c => c.CustomerID === g.CustomerID)?.CustomerName || g.CustomerID}</p>
                </div>
                <span
                  className={`text-xs px-3 py-1 rounded-full ${g.Status === "Active"
                    ? "bg-green-100 text-green-600"
                    : g.Status === "Inactive"
                      ? "bg-gray-100 text-gray-600"
                      : g.Status === "Maintenance"
                        ? "bg-yellow-100 text-yellow-600"
                        : "bg-blue-100 text-blue-600"
                    }`}
                >
                  {g.Status}
                </span>
              </div>

              <div className="flex items-center gap-2 my-3 text-gray-500">
                <FaMapMarkerAlt />
                <p>{g.Location || "N/A"}</p>
              </div>

              <div className="flex justify-between text-sm text-gray-600 my-3">
                <div>
                  <p>
                    <strong>{g.SizeSpaces || 0}</strong> spaces
                  </p>
                  <p>Capacity</p>
                </div>
                <div>
                  <p>
                    <strong>${g.TransientRate?.toFixed(2) || "0.00"}</strong>
                  </p>
                  <p>Transient Rate</p>
                </div>
              </div>

              <div className="flex justify-between text-sm text-gray-600 my-3">
                <div>
                  <p>
                    <strong>${g.MonthlyFixedCharges?.toFixed(2) || "0.00"}</strong>
                  </p>
                  <p>Monthly Fixed</p>
                </div>
                <div>
                  <p>
                    <strong>${g.RatePerPermit?.toFixed(2) || "0.00"}</strong>
                  </p>
                  <p>Permit Rate</p>
                </div>
              </div>

              <hr className="my-3" />

              <p className="text-sm text-gray-400 mb-1">
                Updated{" "}
                {new Date(g.CreatedAt || Date.now()).toLocaleDateString()}
              </p>

              {/* uploaded filename */}
              {g.sow_filename ? (
                <p className="text-xs bg-blue-50 p-2 rounded-ls text-gray-500 mb-3">
                  Uploaded filename : {g.sow_filename}
                </p>
              ) : null}

              {/* <div className="flex justify-end gap-3">
                <button
                  className="px-4 py-1 rounded bg-gray-100 flex items-center gap-1"
                  onClick={() => openForm(g)}
                >
                  <FiEdit /> Edit
                </button>
                <button
                  className="px-4 py-1 rounded bg-red-100 text-red-600 flex items-center gap-1"
                  onClick={() => deleteGarage(g.GarageID)}
                >
                  <FiTrash2 /> Delete
                </button>
              </div> */}

              <div className="flex flex-wrap gap-2 justify-end">

                {/* Upload */}
                <label className="cursor-pointer">
                  <input
                    type="file"
                    accept="application/pdf"
                    className="hidden"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (!file) return;

                      handleUploadSOW(g.GarageID, file);
                      e.target.value = null;
                    }}
                  />

                  <div
                    className={`h-[36px] px-2 rounded flex items-center gap-2 text-sm font-medium
      ${uploadingGarageId === g.GarageID
                        ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                        : "bg-indigo-50 text-indigo-600 hover:bg-indigo-100"
                      }`}
                  >
                    <FiUpload />
                    {uploadingGarageId === g.GarageID
                      ? "Uploading"
                      : g.sow_filename
                        ? "Replace"
                        : "Upload"}
                  </div>
                </label>

                {/* Download */}
                <button
                  disabled={!g.sow_filename || downloadingGarageId === g.GarageID}
                  onClick={() => handleDownloadSOW(g.GarageID, g.sow_filename)}
                  className={`h-[36px] px-2 rounded flex items-center gap-2 text-sm font-medium
    ${!g.sow_filename
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-green-50 text-green-600 hover:bg-green-100"
                    }`}
                >
                  <FiDownload />
                  {downloadingGarageId === g.GarageID
                    ? "Downloading"
                    : "Download"}
                </button>

                {/* Edit */}
                <button
                  className="h-[36px] px-2 rounded bg-gray-100 hover:bg-gray-200 flex items-center gap-2 text-sm font-medium"
                  onClick={() => openForm(g)}
                >
                  <FiEdit />
                  Edit
                </button>

                {/* Delete */}
                <button
                  className="h-[36px] px-2 rounded bg-red-50 text-red-600 hover:bg-red-100 flex items-center gap-2 text-sm font-medium"
                  onClick={() => deleteGarage(g.GarageID)}
                >
                  <FiTrash2 />
                  Delete
                </button>

              </div>
            </div>
          ))}
        </div>
      )}

      {/* TABLE VIEW */}
      {view === "table" && (
        <table className="w-full bg-white shadow rounded-lg">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 text-left">Garage Name</th>
              <th className="p-3 text-left">Customer</th>
              <th className="p-3 text-left">Location</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-left">Capacity</th>
              <th className="p-3 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredGarages.map((g) => (
              <tr key={g.GarageID} className="border-b">
                <td className="p-3">{g.GarageName}</td>
                <td className="p-3">{customers.find(c => c.CustomerID === g.CustomerID)?.CustomerName || g.CustomerID}</td>
                <td className="p-3">{g.Location}</td>
                <td className="p-3">{g.Status}</td>
                <td className="p-3">{g.SizeSpaces}</td>
                <td className="p-3 flex gap-3">
                  {/* Upload */}
                  <label className="cursor-pointer">
                    <input
                      type="file"
                      accept="application/pdf"
                      className="hidden"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (!file) return;

                        handleUploadSOW(g.GarageID, file);
                        e.target.value = null;
                      }}
                    />
                    <div
                      className={`p-2 rounded text-indigo-600 hover:bg-indigo-50 ${
                        uploadingGarageId === g.GarageID ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                      title={uploadingGarageId === g.GarageID ? "Uploading..." : g.sow_filename ? "Replace SOW" : "Upload SOW"}
                    >
                      <FiUpload />
                    </div>
                  </label>

                  {/* Download */}
                  <button
                    disabled={!g.sow_filename || downloadingGarageId === g.GarageID}
                    onClick={() => handleDownloadSOW(g.GarageID, g.sow_filename)}
                    className={`p-2 rounded ${
                      !g.sow_filename
                        ? "text-gray-400 cursor-not-allowed"
                        : "text-green-600 hover:bg-green-50"
                    }`}
                    title={downloadingGarageId === g.GarageID ? "Downloading..." : "Download SOW"}
                  >
                    <FiDownload />
                  </button>

                  <button className="text-blue-600 p-2 rounded hover:bg-blue-50" onClick={() => openForm(g)} title="Edit">
                    <FiEdit />
                  </button>
                  <button className="text-red-600 p-2 rounded hover:bg-red-50" onClick={() => deleteGarage(g.GarageID)} title="Delete">
                    <FiTrash2 />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* ADD/EDIT FORM MODAL */}
      {formOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center overflow-auto z-50 p-6">
          <div className="bg-white w-[900px] max-h-[90vh] overflow-y-auto p-8 rounded-xl shadow-lg">

            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold">
                {formData.GarageID ? "Edit Garage Site" : "Add New Garage Site"}
              </h2>
              <button
                onClick={() => setFormOpen(false)}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                <IoClose />
              </button>
            </div>

            <p className="text-xs text-gray-500 mb-4">
              Fields marked with <span className="text-red-500">*</span> are required
            </p>

            <div className="grid grid-cols-2 gap-4 mb-6">

              {/* Garage ID */}
              <div>
                <label className="text-sm text-gray-600">
                  Garage ID <span className="text-red-500"> *</span>
                </label>
                <input
                  required
                  type="text"
                  placeholder="Enter unique garage ID"
                  className="border w-full p-2 rounded"
                  value={formData.GarageID}
                  onChange={(e) => setFormData({ ...formData, GarageID: e.target.value })}
                  // Only lock the field when editing an existing garage
                  disabled={formData.mode === "edit"}

                />
              </div>

              {/* Customer */}
              <div>
                <label className="text-sm text-gray-600">
                  Customer<span className="text-red-500"> *</span>
                </label>
                <select
                  required
                  className="border w-full p-2 rounded"
                  value={formData.CustomerID}
                  onChange={(e) => setFormData({ ...formData, CustomerID: e.target.value })}
                >
                  <option value="">Select customer<span className="text-red-500"> *</span></option>
                  {customers.map((c) => (
                    <option key={c.CustomerID} value={c.CustomerID}>
                      {c.CustomerName || c.Corporation || c.CustomerID}
                    </option>
                  ))}
                </select>
              </div>

              {/* Customer ID (read-only) */}
              <div>
                <label className="text-sm text-gray-600">Customer ID</label>
                <input
                  type="text"
                  className="border w-full p-2 rounded bg-gray-100"
                  value={formData.CustomerID || ""}
                  readOnly
                  disabled
                />
              </div>

              {/* Status */}
              <div>
                <label className="text-sm text-gray-600">Status<span className="text-red-500"> *</span></label>
                <select
                  className="border w-full p-2 rounded"
                  required
                  value={formData.Status}
                  onChange={(e) => setFormData({ ...formData, Status: e.target.value })}
                >
                  {statusOptions.map((status) => (
                    <option key={status} value={status}>{status}</option>
                  ))}
                </select>
              </div>

              {/* Garage Name */}
              <div>
                <label className="text-sm text-gray-600">Garage Name<span className="text-red-500"> *</span></label>
                <input
                  type="text"
                  required
                  placeholder="Enter garage name"
                  className="border w-full p-2 rounded"
                  value={formData.GarageName}
                  onChange={(e) => setFormData({ ...formData, GarageName: e.target.value })}
                />
              </div>

              {/* Location */}
              <div>
                <label className="text-sm text-gray-600">Location</label>
                <input
                  type="text"
                  placeholder="e.g., Downtown Core"
                  className="border w-full p-2 rounded"
                  value={formData.Location}
                  onChange={(e) => setFormData({ ...formData, Location: e.target.value })}
                />
              </div>

              {/* Size Spaces */}
              <div>
                <label className="text-sm text-gray-600">Size (Spaces Capacity)</label>
                <input
                  type="number"
                  placeholder="1"
                  className="border w-full p-2 rounded"
                  min={1}
                  value={formData.SizeSpaces}
                  onChange={(e) => setFormData({ ...formData, SizeSpaces: Number(e.target.value) })}
                />
              </div>

              {/* Number of Entry Gates */}
              <div>
                <label className="text-sm text-gray-600">Number of Entry Gates</label>
                <input
                  type="number"
                  min={0}
                  className="border w-full p-2 rounded"
                  value={formData.EntryGates}
                  onChange={(e) =>
                    setFormData({ ...formData, EntryGates: Number(e.target.value) })
                  }
                />
              </div>

              {/* Number of Exit Gates */}
              <div>
                <label className="text-sm text-gray-600">Number of Exit Gates</label>
                <input
                  type="number"
                  min={0}
                  className="border w-full p-2 rounded"
                  value={formData.ExitGates}
                  onChange={(e) =>
                    setFormData({ ...formData, ExitGates: Number(e.target.value) })
                  }
                />
              </div>

              {/* Address */}
              <div className="col-span-2">
                <label className="text-sm text-gray-600">Address</label>
                <input
                  type="text"
                  placeholder="Enter full address"
                  className="border w-full p-2 rounded"
                  value={formData.Address}
                  onChange={(e) => setFormData({ ...formData, Address: e.target.value })}
                />
              </div>

            </div>

            {/* Pricing Configuration */}
            <h3 className="text-lg font-semibold mb-4">Pricing Configuration</h3>

            <div className="grid grid-cols-3 gap-4">

              {[
                { label: "Transient Rate ($)", key: "TransientRate" },
                { label: "Free Transient Allowed", key: "FreeTransientAllowed" },
                { label: "Transient Rate free rate ($)", key: "TransientFreeRate" },
                { label: "Free transient free allowed", key: "FreeTransientFreeAllowed" },
                { label: "Reservations Rate ($)", key: "ReservationsRate" },
                { label: "Free Reservations Allowed", key: "FreeReservationsAllowed" },
                { label: "Rate per Permit ($)", key: "RatePerPermit" },
                { label: "Free Permit Allowed", key: "FreePermitAllowed" },
                { label: "License Rate ($)", key: "RatePerApp" },
                { label: "Free App Allowed", key: "FreeAppAllowed" },
                { label: "Events Rate ($)", key: "EventsRate" },
                { label: "Free Events Allowed", key: "FreeEventsAllowed" },
                { label: "Passes Rate ($)", key: "PassesRate" },
                { label: "Free Passes Allowed", key: "FreePassesAllowed" },
                { label: "Monthly Fixed Charges ($)", key: "MonthlyFixedCharges" },
                { label: "Gateway Fees ($)", key: "GatewayFees" },
                { label: "No. of Active Licenses", key: "ActiveLicenses" },
                { label: "Citation Charges ($)", key: "citation_charges" },
                { label: "Amount Collected Charges ($)", key: "amount_collected_charges" },
                { label: "Parking Validation Service ($)", key: "parking_validation_service" },
              ].map(({ label, key }) => {
                const disabled = isFieldDisabled(key);
                return (
                  <div key={key}>
                    <label className="text-sm text-gray-600">{label}</label>
                    <input
                      type={label.includes("Allowed") ? "number" : "number"}
                      step={label.includes("Rate") || label.includes("Charges") || label.includes("Fees") ? "0.01" : "1"}
                      min={0}
                      disabled={disabled}
                      className={`border w-full p-2 rounded ${disabled ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}`}
                      value={formData[key]}
                      onChange={(e) => {
                        if (disabled) return;
                        const val = e.target.value;
                        setFormData({
                          ...formData,
                          [key]: val === "" ? "" : Number(val)
                        });
                      }}
                    />
                  </div>
                );
              })}

            </div>

            {/* Taxes */}
            <h3 className="text-lg font-semibold mb-4 mt-6">Taxes</h3>

            <div className="grid grid-cols-3 gap-4">
              <div>
                <label className="text-sm text-gray-600">Items Tax ($)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  className="border w-full p-2 rounded"
                  value={formData.items_tax}
                  onChange={(e) => {
                    const val = e.target.value;
                    setFormData({
                      ...formData,
                      items_tax: val === "" ? "" : Number(val)
                    });
                  }}
                />
              </div>

              <div>
                <label className="text-sm text-gray-600">Installation Tax ($)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  className="border w-full p-2 rounded"
                  value={formData.installation_tax}
                  onChange={(e) => {
                    const val = e.target.value;
                    setFormData({
                      ...formData,
                      installation_tax: val === "" ? "" : Number(val)
                    });
                  }}
                />
              </div>

              <div>
                <label className="text-sm text-gray-600">Subscription Tax ($)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  className="border w-full p-2 rounded"
                  value={formData.subscription_tax}
                  onChange={(e) => {
                    const val = e.target.value;
                    setFormData({
                      ...formData,
                      subscription_tax: val === "" ? "" : Number(val)
                    });
                  }}
                />
              </div>
            </div>

            {/* Installation / Labour Expenses */}
            <h3 className="text-lg font-semibold mb-4 mt-6">
              Installation / Labour Expenses
            </h3>

            {/* Header */}
            <div className="grid grid-cols-12 gap-3 font-semibold text-sm text-gray-600 mb-2">
              <div className="col-span-4">Expense Name</div>
              <div className="col-span-3">Quantity</div>
              <div className="col-span-3">Price ($)</div>
              <div className="col-span-2">Actions</div>
            </div>

            {/* Rows */}
            <div className="space-y-2">
              {installationExpenses.map((item, index) => (
                <div key={index} className="grid grid-cols-12 gap-3 items-center">

                  {/* Name */}
                  <input
                    type="text"
                    placeholder="Expense Name"
                    value={item.expense_name}
                    onChange={(e) =>
                      handleExpenseChange(index, "expense_name", e.target.value)
                    }
                    className="col-span-4 border rounded px-3 py-2"
                  />

                  {/* Quantity */}
                  <input
                    type="number"
                    min="1"
                    value={item.expense_quantity}
                    onChange={(e) =>
                      handleExpenseChange(index, "expense_quantity", e.target.value)
                    }
                    className="col-span-3 border rounded px-3 py-2"
                  />

                  {/* Price */}
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    value={item.price}
                    onChange={(e) =>
                      handleExpenseChange(index, "price", e.target.value)
                    }
                    className="col-span-3 border rounded px-3 py-2"
                  />

                  {/* Delete */}
                  <button
                    type="button"
                    onClick={() => removeExpenseRow(index)}
                    className="col-span-2 text-red-500 hover:text-red-700 text-xl flex justify-center"
                  >
                    <FiTrash2 />
                  </button>

                </div>
              ))}
            </div>

            {/* Add Button */}
            <button
              type="button"
              onClick={addExpenseRow}
              className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700"
            >
              <IoAddCircleOutline /> Add Expense
            </button>

            {/* Subscription Services */}
            <h3 className="text-lg font-semibold mb-4 mt-5">Subscription Services</h3>

            {/* Header Row */}
            <div className="grid grid-cols-12 gap-3 font-semibold text-sm text-gray-600 mb-2">
              <div className="col-span-4">Subscription Name</div>
              <div className="col-span-3">Monthly Price</div>
              <div className="col-span-3">Billing Unit</div>
              <div className="col-span-2">Actions</div>
            </div>

            {/* Subscription Rows */}
            <div className="space-y-2">
              {subscriptionServices.map((service, index) => (
                <div key={index} className="grid grid-cols-12 gap-3 items-center">
                  {/* Name */}
                  <input
                    type="text"
                    placeholder="Subscription Name"
                    value={service.item_name}
                    onChange={(e) =>
                      handleSubscriptionChange(index, "item_name", e.target.value)
                    }
                    className="col-span-4 border rounded px-3 py-2"
                  />

                  {/* Monthly Price */}
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    placeholder="0.00"
                    value={service.monthly_price}
                    onChange={(e) =>
                      handleSubscriptionChange(index, "monthly_price", e.target.value)
                    }
                    className="col-span-3 border rounded px-3 py-2"
                  />

                  {/* Billing Unit */}
                  <input
                    type="text"
                    placeholder="Billing Unit"
                    value={service.billing_unit}
                    onChange={(e) =>
                      handleSubscriptionChange(index, "billing_unit", e.target.value)
                    }
                    className="col-span-3 border rounded px-3 py-2"
                  />

                  {/* Delete Icon */}
                  <button
                    type="button"
                    onClick={() => removeSubscriptionRow(index)}
                    className="col-span-2 text-red-500 hover:text-red-700 text-xl flex justify-center"
                  >
                    <FiTrash2 />
                  </button>
                </div>

              ))}
            </div>

            {/* Add Button */}
            <button
              type="button"
              onClick={addSubscriptionRow}
              className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700"
            >
              <IoAddCircleOutline /> Add Subscription Service
            </button>

            {/* Contract Terms Section */}
            <h3 className="text-lg font-semibold mt-8 mb-4">
              Contract Terms
            </h3>

            <div className="space-y-4">

              {/* Subscription Term */}
              <div>
                <label className="text-sm text-gray-600">
                  Term of Subscription and Termination
                </label>
                <textarea
                  className="border w-full p-3 rounded-lg min-h-[120px]"
                  placeholder="Enter subscription term details..."
                  value={formData.subscription_terms || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      subscription_terms: e.target.value
                    })
                  }
                />
              </div>

              {/* Payment Terms */}
              <div>
                <label className="text-sm text-gray-600">
                  Payment Terms
                </label>
                <textarea
                  className="border w-full p-3 rounded-lg min-h-[100px]"
                  placeholder="Enter payment terms..."
                  value={formData.payment_terms || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      payment_terms: e.target.value
                    })
                  }
                />
              </div>

            </div>

            {/* BUTTONS */}
            <div className="flex justify-end gap-4 mt-6">
              <button
                className="px-6 py-2 bg-gray-300 rounded-lg"
                onClick={() => setFormOpen(false)}
              >
                Cancel
              </button>
              <button
                className="px-6 py-2 bg-blue-600 text-white rounded-lg"
                onClick={handleSave}
              >
                {formData.GarageID ? "Save Changes" : "Add Garage"}
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}
